import { CSSProperties } from "@mui/styles";
import { TextFieldClassKey, InputBaseClassKey } from "@mui/material";

export const textFieldOverrides: Partial<Record<TextFieldClassKey, CSSProperties>> = {
  root: {
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      border: "solid 2px rgb(124, 176, 199)",
      boxShadow: "0 1px 2px 0 rgba(124, 176, 199)",
      borderRadius: 4,
    },
  },
};

export const inputBaseOverrides: Partial<Record<InputBaseClassKey, CSSProperties>> = {
  root: {
    "&$disabled": {
      backgroundColor: "#B2B2B2",
    },
  },
};
